const BANK_DETAILS = {
	title: {
		text: 'Transfer money only from this account',
		dataAid: 'transferMoneyFrom',
	},
	icon: {
		dataAid: 'left',
	},
	bankAccount: {
		dataAid: 'title',
	},
};

const NEFT_DETAILS = {
	title: {
		text: 'To the following bank account',
		dataAid: 'followingBankAccount',
	},
};

const HEADER = {
	text: 'Add funds via NEFT/RTGS/IMPS',
	dataAid: 'neft details',
}

const BANK_NEFT_DETAILS = ({
	account_number = '-',
	ifsc_code = '-',
	name = '-',
	account_type = '-',
	address = '-',
}) => {
	return [
		{
			name: {
				text: 'Name',
				dataAid: 'nameKey',
			},
			value: {
				text: name,
				dataAid: 'companyName',
			},
			isCopyIcon: true,
		},
		{
			name: {
				text: 'Account number',
				dataAid: 'accountNumberKey',
			},
			value: {
				text: account_number,
				dataAid: 'fisnse',
			},
			isCopyIcon: true,
		},
		{
			name: {
				text: 'IFSC code',
				dataAid: 'ifscKey',
			},
			value: {
				text: ifsc_code,
				dataAid: 'ifscValue',
			},
			isCopyIcon: true,
		},
		{
			name: {
				text: 'Account type',
				dataAid: 'accountTypeKey',
			},
			value: {
				text: account_type,
				dataAid: 'accountTypeValue',
			},
			isCopyIcon: false,
		},
		{
			name: {
				text: 'Branch address',
				dataAid: 'branchAddressKey',
			},
			value: {
				text: address,
				dataAid: 'branchAddressValue',
			},
			isCopyIcon: false,
		},
	];
};

const NOTE = {
	text: 'Note: NEFT/RTGS fund transfers may take up to 4 hours to reflect in your Trading Account',
	dataAid: 'note',
};

const MISCELLANEOUS = {
	toast: 'Code Copied'
}

const PAYMENT_NEFT = {
	BANK_DETAILS,
	NEFT_DETAILS,
	NOTE,
	BANK_NEFT_DETAILS,
	HEADER,
	MISCELLANEOUS,
};

export default PAYMENT_NEFT;
